import ServiceProvider from './ServiceProvider'

export default ServiceProvider